import type {ReactElement} from 'react';
import type {RGBA} from '@Utils/color.util';
import {hexToRgba} from '@Libraries/qr-code/qr-render.library';
import {HexPicker} from '@Components/color-picker-v2/components/hex-picker';
import {PickerInputField} from '@Components/color-picker-v2/components/picker-input-field';
import {AlphaPercentagePickerInputField} from '@Components/color-picker-v2/components/alpha-percentage-picker-input-field/alpha-percentage-picker-input-field';
import {EyedropperColorPicker, EyeDropperCTAType} from '@Components/eyedropper-color-picker/eyedropper-color-picker';
import styles from './qr-color-picker.module.scss';
import type {QRColorPickerProps} from './qr-color-picker.types';

export function QRColorPicker({color, onColorChange}: QRColorPickerProps): ReactElement {
  const applyColor = (updatedColor: RGBA | null): void => {
    if (updatedColor === null) {
      return;
    }
    onColorChange(updatedColor);
  };

  return (
    <div className={styles.qrColorPicker}>
      <HexPicker color={color} onChange={applyColor} onChangeEnded={applyColor} />
      <div className={styles.qrColorPickerFields}>
        <div className={styles.qrColorPickerInputGroup}>
          <div className={styles.qrColorPickerHexInput}>
            <PickerInputField
              color={color}
              onChangeColor={applyColor}
              onChangeEnded={applyColor}
              inputContainerClassName={styles.qrColorPickerInputHeight}
              inputClassname={styles.qrColorPickerBorderlessInput}
            />
          </div>
          <div className={styles.qrColorPickerDivider} />
          <div className={styles.qrColorPickerAlphaInput}>
            <AlphaPercentagePickerInputField
              color={color}
              onChangeColor={applyColor}
              onChangeEnded={applyColor}
              className={styles.qrColorPickerInputHeight}
              inputClassName={styles.qrColorPickerBorderlessInput}
            />
          </div>
        </div>
        <EyedropperColorPicker
          ctaType={EyeDropperCTAType.ICON}
          onColorPicked={(pickedHexColor: string): void => {
            onColorChange(hexToRgba(pickedHexColor, color[3]));
          }}
        />
      </div>
    </div>
  );
}
